import { Fragment } from "react";
import { ScrollRestoration, useSearchParams } from "react-router-dom";
import PublicHeader from "../../../components/layouts/PublicHeader";
import { renderNavItem } from "../utils/contentNavBar";
import GeneralAccordion from "../../../components/ui/accordions/GeneralAccordion";
import { HELP_CONTENT } from "./centers/centersContent";

function HelpCenter() {
  const [searchParams] = useSearchParams();
  const rawFilter = searchParams.get("filter");
  const filter = HELP_CONTENT[rawFilter] ? rawFilter : "filings";
  const path = "/help-center";

  // Get the array of sections for the current tab
  const activeSections = HELP_CONTENT[filter];

  return (
    <Fragment>
      <ScrollRestoration />
      <PublicHeader
        title="Help Center"
        description="Clear answers about how Plaintr works — and how to get the most from it."
      />
      <div id="container">
        <div className="offerings-container">
          <section className="offerings-nav">
            {renderNavItem(path, filter, "filings", "For Filings")}
            {renderNavItem(path, filter, "providers", "For Providers")}
            {renderNavItem(path, filter, "affiliates", "For Affiliates")}
          </section>

          <section className="offerings-content">
            {activeSections.map((item, index) => (
              <GeneralAccordion key={`${filter}-${index}`} title={item.title}>
                {item.content}
              </GeneralAccordion>
            ))}
          </section>
        </div>
      </div>
    </Fragment>
  );
}

export default HelpCenter;
